import React from 'react';
import AssessmentsView from '../Assessments/AssessmentsView';
import { useStores } from '../../hooks/use-stores';
import { joinPath } from '../../utils/helpers';
import { useResolvedPath, useNavigate } from 'react-router-dom';

function InfosecAssessment({
    availableLanguages,
    variant = 'infosec',
     parentUrl
}) {
    const navigate = useNavigate();
    const {
        assessmentStore,
        authStore,
        commonStore,
        questionStore,
        infosecStore,
    } = useStores();

    const resolved = useResolvedPath('.');
    const baseUrl = resolved.pathname;


    const { currentUser } = authStore;
    const handleOnFinish = () => {
        commonStore.saveAnalyticsEvent('mini-hra', 'finished', {
            miniHRAType: variant,
            emailOption:
                (currentUser && currentUser.emailOption) ||
                infosecStore.emailOption,
            page: window.location.pathname,
            eventName: 'userAction',
        });
        const path = joinPath(parentUrl, 'finish')
        navigate( path );
    };

    const handleOnQuestionComplete = (questionId) => {
        commonStore.saveAnalyticsEvent('mini-hra', 'question-complete', {
            isLastQuestion: false,
            miniHRAType: variant,
            questionId,
            emailOption:
                (currentUser && currentUser.emailOption) ||
                infosecStore.emailOption,
            page: window.location.pathname,
            eventName: 'userAction',
        });
    };
    const handleOnLastQuestionComplete = (questionId) => {
        commonStore.saveAnalyticsEvent('mini-hra', 'question-complete', {
            isLastQuestion: true,
            miniHRAType: variant,
            questionId,
            emailOption:
                (currentUser && currentUser.emailOption) ||
                infosecStore.emailOption,
            page: window.location.pathname,
            eventName: 'userAction',
        });
    };

    const handleOnShowResults = (questionId) => {
        commonStore.saveAnalyticsEvent('mini-hra', 'show-results', {
            miniHRAType: variant,
            questionId,
            emailOption:
                (currentUser && currentUser.emailOption) ||
                infosecStore.emailOption,
            page: window.location.pathname,
            eventName: 'page-view',
        });
    };


    console.log("Rendering InfosecAssessment for variant:", variant);
    return (
        <AssessmentsView
            parentUrl={baseUrl}
            currentUser={currentUser}
            companyId={variant}
            assessmentId={variant}
            assessmentStore={assessmentStore}
            questionStore={questionStore}
            language={assessmentStore.language}
            isInfosec={true}
            onClose={handleOnFinish}
            handleOnQuestionComplete={handleOnQuestionComplete}
            handleOnFinish={handleOnLastQuestionComplete}
            onShowResults={handleOnShowResults}
            availableLanguages={availableLanguages}
        />
    );
}

export default InfosecAssessment;
